import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { GlobalProvider } from './context/GlobalState';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';

import Panel from './components/Panel';
import Maps from './components/Maps';
import Tours from './components/Tours';

const theme = createTheme({
  typography: {
    fontFamily: [
      'interstate',
      'HelveticaNeue',
      'HelveticaNeue neue',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: 18,
      color: '#3C3D3F',
      margin: '0 0 10px 0',
      fontWeight: 400,
    },
    h2: {
      fontSize: 18,
      color: '#3C3D3F',
      margin: '24px 0 10px 0',
      fontWeight: 400,
    },
  },
  palette: {
    primary: {
      main: '#C81F45',
    },
    secondary: {
      main: '#00A3B4',
    },
    success: {
      main: '#92BB3E',
    },
  },
  zIndex: {
    appBar: 1201,
  },
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '32px',
          width: '32px',
          height: '32px',
          marginRight: '10px',
        },
      },
    },
  },
});

export default function App() {
  return (
    <BrowserRouter>
      <GlobalProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
              <Route
                path='/'
                element={
                  <>
                    <Panel />
                    <Outlet />
                  </>
                }
              >
                <Route path='maps' element={<Maps />} />
                <Route path='maps/:tour/:area' element={<Tours />} />
              </Route>
            </Routes>
          </ThemeProvider>
        </StyledEngineProvider>
      </GlobalProvider>
    </BrowserRouter>
  );
}
